define('views/search/advanced',[
  "backbone",
  "./types",
  "./scope"
], function (Backbone, TypesView, ScopeView) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click .scope-toggle": "toggleScope",
      "click .clear-filters": "clear"
    },

    initialize: function () {
      _.bindAll(this, "updateInterfaceState", "toggleScope");

      this.types = new TypesView({
        el: $(".types"),
        model: this.model,
        button: this.$(".dropdown-toggle")
      });

      this.scope = new ScopeView({
        el: $("#scope-tree"),
        model: this.model,
        button: this.$(".scope-toggle")
      });

      this.model.on("change:type change:scope",
        this.updateInterfaceState, this);

      this.render();
    },

    render: function () {
      this.$el.toggle(150);
      return this;
    },

    clear: function () {
      this.model.unset("type");
      this.model.unset("scope").trigger("reset");
      return this;
    },

    toggleScope: function () {
      this.scope.toggle(150);
      return this;
    },

    hasActiveFilters: function () {
      return this.model.has("type") || this.model.has("scope");
    },

    updateInterfaceState: function () {
      this.$(".clear-filters").prop("disabled", !this.hasActiveFilters());
      return this;
    }
  });
});

